import * as React from 'react';
import { Checkbox } from 'wix-style-react';

export interface Props {
  dataHook: string;
  initialState: boolean;
  hasError: boolean;
  onChange(checked: boolean): void;
}

export const ReviewCookieCheckbox: React.FunctionComponent<Props> = ({
  initialState,
  onChange,
  dataHook,
  children,
  hasError,
}) => {
  const [checked, setChecked] = React.useState(initialState);
  const onCheckedChange = () => {
    const newState = !checked;
    setChecked(newState);
    onChange(newState);
  };
  return (
    <Checkbox hasError={hasError} checked={checked} onChange={onCheckedChange} dataHook={dataHook}>
      {children}
    </Checkbox>
  );
};
